var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  style: {
    margin: "auto",
    background: "0 0"
  },
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid",
  display: "block"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  fill: "none",
  stroke: "#06c167",
  strokeWidth: 3,
  r: 35,
  strokeDasharray: "164.93361431346415 56.97787143782138"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  repeatCount: "indefinite",
  dur: "1s",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1"
}))));
export default SvgSpinner;